var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"pega-comment-bar"},_vm._l((_vm.comments),function(value,i){return _c('preview-job-comment',_vm._g({key:((value.id) + "-" + i),attrs:{"job-comment":value}},_vm.$listeners))}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }